
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 3.25A2.75 2.75 0 005.25 6v3c0 .674-.18 1.286-.46 1.705-.279.419-.58.545-.79.545a.75.75 0 000 1.5c.21 0 .511.126.79.545.28.419.46 1.03.46 1.705v3A2.75 2.75 0 008 20.75a.75.75 0 000-1.5A1.25 1.25 0 016.75 18v-3c0-.917-.24-1.831-.712-2.537A3.212 3.212 0 005.665 12c.137-.14.262-.296.373-.463.471-.706.712-1.62.712-2.537V6A1.25 1.25 0 018 4.75a.75.75 0 000-1.5zm8 0a.75.75 0 000 1.5A1.25 1.25 0 0117.25 6v3c0 .917.24 1.831.712 2.537.11.167.236.323.373.463-.137.14-.262.296-.373.463-.471.706-.712 1.62-.712 2.537v3A1.25 1.25 0 0116 19.25a.75.75 0 000 1.5A2.75 2.75 0 0018.75 18v-3c0-.674.18-1.286.46-1.705.279-.419.58-.545.79-.545a.75.75 0 000-1.5c-.21 0-.511-.126-.79-.545-.28-.419-.46-1.03-.46-1.705V6A2.75 2.75 0 0016 3.25z"}})])
          )
        }
      }
    